/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit FinalizeAndCreateTaskOption/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import LoadingSpinner from 'DesignSystem/LoadingSpinner/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function FinalizeAndCreateTaskOption({
  children,
  viewPath = "/DesignSystem/PreviewDocumentModal/Content/Content/HtmlFile/Content/Content/Content/Footer/FinalizeAction/Content/FinalizeAndCreateTaskOption"
  
}) {
let editorSavingValueData = fromData.useDataValue({ viewPath,
context: 'editor',
path: 'saving',
})
let editorDisabledValueData = fromData.useDataValue({ viewPath,
context: 'editor',
path: 'disabled',
})
let aggregateData = fromAggregate.any(editorSavingValueData, editorDisabledValueData)
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let editorFinalizeAndCreateTaskLoadingValueData = fromData.useDataValue({ viewPath,
context: 'editor',
path: 'finalize_and_create_task_loading',
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="ghost"
 marginTop={dtSpaceXxxs}
 marginBottom={1}
 cursor="pointer"
 alignItems="center"
 width="100%"
 onClick={onClick}
 data="editor.saving"
 data="editor.disabled"
 aggregate="/Simple/Data/aggregate.js any"
 disabled={aggregateData}
>
{childProps => (
<React.Fragment>
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 backgroundColor={dtColorsNeutral900}
 text="Finalize and create task"
/>
<fromFlow.When is={editorFinalizeAndCreateTaskLoadingValueData}>
<div
  data-testid="FinalizeAndCreateTaskOption.Vertical"
  data-view-path={viewPath}
 style={{'--ml-1-11Md7x': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs}}
 className={`views-block ${styles.Vertical}`}
>
<LoadingSpinner
  viewPath={`${viewPath}/LoadingSpinner`}
 height={16}
 width={16}
/>
</div>
</fromFlow.When>
</React.Fragment>
)}
</TysiaButton>
{children}
</React.Fragment>)
}